/* Copyright (c) 2026 Goffy. All Rights Reserved. */

:root {
  --goffy-date-bg: #0b1224;
  --goffy-date-panel: #0f1c3c;
  --goffy-date-border: #1f2d4f;
  --goffy-date-text: #e5edff;
  --goffy-date-muted: #94a3b8;
  --goffy-date-accent: #38bdf8;
  --goffy-date-accent-strong: #0ea5e9;
}

.goffy-date-picker-wrapper {
  width: 100%;
}

.goffy-date-picker {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--goffy-date-border);
  padding: 8px 10px;
  background: var(--goffy-date-bg);
  color: var(--goffy-date-text);
  font-size: 14px;
}

.react-datepicker {
  background-color: var(--goffy-date-panel);
  border: 1px solid var(--goffy-date-border);
  color: var(--goffy-date-text);
  font-family: inherit;
}

.react-datepicker__header {
  background-color: var(--goffy-date-panel);
  border-bottom: 1px solid var(--goffy-date-border);
}

.react-datepicker__current-month,
.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: var(--goffy-date-text);
}

.react-datepicker__day--outside-month {
  color: var(--goffy-date-muted);
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  background-color: rgba(56, 189, 248, 0.2);
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: var(--goffy-date-accent-strong);
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.65);
}

.react-datepicker__navigation-icon::before {
  border-color: var(--goffy-date-text);
}

.react-datepicker__triangle::before,
.react-datepicker__triangle::after {
  border-bottom-color: var(--goffy-date-panel);
}

/* Inline datepicker doesn't use portal/poppers. */
